document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".heroSwiper");

  if (!slider) return;

  const section = slider.closest(".hero-slider-section");

  const autoplayEnabled =
    section?.dataset.autoplay === "true";

  const autoplaySpeed =
    parseInt(section?.dataset.speed || "5000", 10);

  const swiper = new Swiper(".heroSwiper", {

    loop: true,

    speed: 1000,

    effect: "fade",

    fadeEffect: {
      crossFade: true
    },

    preloadImages: false,

    lazy: {
      loadPrevNext: true
    },

    watchSlidesProgress: true,

    observer: true,

    observeParents: true,

    keyboard: {
      enabled: true
    },

    autoplay: autoplayEnabled
      ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      : false,

    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    on: {

      init: function () {

        animateSlide(this.slides[this.activeIndex]);

      },

      slideChangeTransitionStart: function () {

        resetAnimations();

      },

      slideChangeTransitionEnd: function () {

        animateSlide(this.slides[this.activeIndex]);

      }

    }

  });

  function resetAnimations() {

    document.querySelectorAll(".hero-content .animate").forEach((el) => {

      el.style.opacity = "0";
      el.style.transform = "translateY(45px)";

    });

  }

  function animateSlide(slide) {

    if (!slide) return;

    const elements = slide.querySelectorAll(".animate");

    elements.forEach((el, index) => {

      setTimeout(() => {

        el.style.opacity = "1";
        el.style.transform = "translateY(0)";

      }, index * 180);

    });

  }

});